import { render, staticRenderFns } from "./ReportPreExistingDamage.vue?vue&type=template&id=918a011e"
import script from "./ReportPreExistingDamage.vue?vue&type=script&lang=ts"
export * from "./ReportPreExistingDamage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports